var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"width65",attrs:{"id":"multiSlider"}},[_c('VueSlickCarousel',_vm._b({},'VueSlickCarousel',_vm.sliderSettings,false),_vm._l((_vm.data),function(blog){return _c('cart',{key:blog.id,attrs:{"blog":blog}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }